/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TripDriver
 */
export interface TripDriver {
    /**
     * 
     * @type {number}
     * @memberof TripDriver
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TripDriver
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TripDriver
     */
    surname: string;
    /**
     * 
     * @type {boolean}
     * @memberof TripDriver
     */
    isMain: boolean;
}

export function TripDriverFromJSON(json: any): TripDriver {
    return TripDriverFromJSONTyped(json, false);
}

export function TripDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'surname': json['surname'],
        'isMain': json['isMain'],
    };
}

export function TripDriverToJSON(value?: TripDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'surname': value.surname,
        'isMain': value.isMain,
    };
}


